import React from "react";
import {motion} from 'framer-motion';


function NavMenu () {

    // ============ Hold the menu on the nav =======================
    const navItems = [

        {
      
          title: "Home",
      
          href: "/#Home",
      
        },
      
        {
      
          title: "Book",
      
          href: "/booking",
      
        },
      
        {
      
          title: "About",
      
          href: "/#About",
      
        },
      
        {
      
          title: "Contact",
      
          href: "/#Contact",
      
        },

        {
      
          title: "Portfolio",
      
          href: "/#Portfolio",
      
        },
      
      ];

    return (
        <motion.div
        className="nav__open"
        initial={{ x: '100%' }}
        animate={{ x: '60vw' }}
        exit={{ x: '100%' }}
      >
        {/* Your navigation content goes here */}
        <div className="open__menu">
            {
                navItems.map( (data, index) => {
                    return <a
                    href={data.href}> {data.title}
                    </a>
                })

            }
          
        </div>
      </motion.div>
    );


}

export default NavMenu;